// src/graphql/mutations/tenderMutations.js

export const createTender = `mutation CreateTender($input: CreateTenderInput!) {
    createTender(input: $input) {
        success
        message
        tender {
            id
            title
            externalId
            status
        }
        error
    }
}`;

export const updateTender = `mutation UpdateTender($id: String!, $input: UpdateTenderInput!) {
    updateTender(id: $id, input: $input) {
        success
        message
        tender {
            id
            title
            status
        }
        error
    }
}`;

export const deleteTender = `mutation DeleteTender($id: String!) {
    deleteTender(id: $id) {
        success
        message
        error
    }
}`;

export const updateCompanyTenderRatings = `mutation UpdateCompanyTenderRatings($tenderId: String!, $input: CompanyTenderRatingsInput!) {
    updateCompanyTenderRatings(tenderId: $tenderId, input: $input) {
        success
        message
        tender {
            id
            title
            status
        }
        error
    }
}`;

// View tracking mutations
export const markTenderViewedFromEmail = `mutation MarkTenderViewedFromEmail($tenderId: String!, $savedSearchId: String!) {
    markTenderViewedFromEmail(tenderId: $tenderId, savedSearchId: $savedSearchId) {
        success
        error
    }
}`;

// Assessment mutations
export const requestAssessment = `mutation RequestAssessment($input: RequestAssessmentInput!) {
    requestAssessment(input: $input) {
        success
        queuePosition
        estimatedProcessingTime
        error
    }
}`;

export const prequalifyTenders = `mutation PrequalifyTenders($input: PrequalifyTendersInput!) {
    prequalifyTenders(input: $input) {
        query
        mustTerms
        optionalTerms
        excludeTerms
        totalMatches
        savedSearchesIncluded
        tenders {
            tenderId
            title
            rank
            snippet
            cpvCodes
            deadline
        }
        assessmentJobsCreated
    }
}`;
